import React from 'react';
import PropTypes from 'prop-types';
import { FormInput, FormContainer, NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';

const CompanyEditForm = ({ fields, formId, onContinue, view }) => {
  const renderedFields = fields.map((fieldProps, index) =>
    <FormInput formId={formId} key={`${index}_${formId}`} {...fieldProps} />
  );

  return (
    <div>
      <FormContainer className={`${formId}__form`} onSubmit={onContinue} formId={formId} >
        <NeuroMessage id={`lookupFlow.${view.current}.title`} tagName='h1' />
        <div className="form-body">{renderedFields}</div>
        <button className="btn btn__primary" type="submit" aria-label='Save'><NeuroMessage id={'lookupFlow.save'} /></button>
      </FormContainer>
    </div>
  );
};

CompanyEditForm.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object), 
  formId: PropTypes.string, 
  onContinue: PropTypes.func, 
  view: PropTypes.object
};

export default CompanyEditForm;
